import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    createPlanVehicleRule,
    createPlanVehicleRules,
    deletePlanVehicleRule,
    updatePlanVehicleRule,
} from '../services/planVehicleRules';
import { planVehicleRulesQueryKey } from './usePlanVehicleRulesQuery';
import type { PlanVehicleRuleBatchPayload, PlanVehicleRulePayload } from '../types/planVehicleRule.types';

export function usePlanVehicleRuleMutations(planId: string) {
    const queryClient = useQueryClient();

    const invalidate = () =>
        queryClient.invalidateQueries({ queryKey: planVehicleRulesQueryKey(planId) });

    return {
        createMutation: useMutation({
            mutationFn: (payload: PlanVehicleRulePayload) => createPlanVehicleRule(planId, payload),
            onSuccess: invalidate,
        }),
        createBatchMutation: useMutation({
            mutationFn: (payload: PlanVehicleRuleBatchPayload) => createPlanVehicleRules(planId, payload),
            onSuccess: invalidate,
        }),
        updateMutation: useMutation({
            mutationFn: ({ ruleId, payload }: { ruleId: string; payload: PlanVehicleRulePayload }) =>
                updatePlanVehicleRule(planId, ruleId, payload),
            onSuccess: invalidate,
        }),
        deleteMutation: useMutation({
            mutationFn: (ruleId: string) => deletePlanVehicleRule(planId, ruleId),
            onSuccess: invalidate,
        }),
    };
}
